import React from 'react'
import PlateNames from '../Step2/PlateNames'
import { configContext } from '../DnaPlates'

const OligoConfiguration = (props) => {
  const { specificationsData, productDetails } = props
  const { dispatch } = React.useContext(configContext)
  React.useEffect(() => {
    window.scrollTo(0, 0)
    dispatch({ type: 'SET_PAGE_ERROR', data: '' })
  }, [])
  return (
    <>
      <PlateNames
        specificationsData={specificationsData}
        productDetails={productDetails}
      />
    </>
  )
}

export default OligoConfiguration
